import React, { useState } from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { cilSettings, cilUser, cilAccountLogout, cilMenu } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { FaRegUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { logoutAction } from "../../views/auth/action";
import { useDispatch, useSelector } from "react-redux";

/**
 * @function AppHeaderDropdown
 * @description for profile dropdown
 * @returns JSX
 */

const AppHeaderDropdown = () => {
  const { profileImage = "" } = useSelector(
    (state) => state.AuthReducer?.adminDetails
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    dispatch(
      logoutAction((response) => {
        if (response.isSuccess) {
          // sessionStorage.clear();
          navigate("/");
        }
      })
    );
  };

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle
        placement="bottom-end"
        className="py-0 pe-0 profile--icon--container "
        caret={false}
      >
        <div className="profile--container">
          {profileImage ? (
            <CAvatar
              src={profileImage}
              className="avatar-img border border-2 "
            />
          ) : (
            <FaRegUserCircle className="avatar-img" />
          )}
        </div>
        <CIcon size="lg" icon={cilMenu} />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-body-secondary fw-semibold mb-2">
          Account
        </CDropdownHeader>
        <CDropdownItem
          onClick={() => navigate("/profile")}
          className="cursor-pointer"
        >
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        {/* <CDropdownItem href="#">
          <CIcon icon={cilSettings} className="me-2" />
          Settings
        </CDropdownItem> */}
        <CDropdownDivider />
        <CDropdownItem onClick={logout} className="cursor-pointer">
          <CIcon icon={cilAccountLogout} className="me-2" />
          LogOut
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
